import { Input, Directive, SimpleChanges, HostBinding, HostListener, ElementRef, OnChanges } from '@angular/core';
import { BsDropdownDirective } from 'ngx-bootstrap/dropdown';

import { VbBaseMenuComponent } from './VbBaseMenu.Component';

@Directive({
	selector: 'vb-nested-selection-menu',
	standalone: false
})
export class VbNestedMenuComponent extends VbBaseMenuComponent implements OnChanges {
	@Input() public parentElement: ElementRef;
	@Input() public activateDropdown: boolean;

	@HostBinding('hidden')
	public get keepHidden() {
		return !this.activateDropdown;
	}

	public ngOnChanges(changes: SimpleChanges): void {
		if (changes.activateDropdown) {
			this.updateDropdownState();
		}
	}

	public set dropdownViewChild(val: BsDropdownDirective) {
		super.dropdownViewChild = val;
		this.updateDropdownState();
	}

	protected updateDropdownState(): void {
		if(!this.dropdown || this.dropdown.isOpen === this.activateDropdown) {
			return;
		}

		if(this.activateDropdown) {
			this.dropdown.show();
		}
		else {
			this.dropdown.hide();
		}
	}

	/**
	 * workaround of outside click.
	 * currently nested menu not fully supported by ngx-bootstrap.
	 */
	@HostListener('document:click', ['$event'])
	public onDocumentClick(event: MouseEvent): void {
		if (this.parentElement.nativeElement.contains(event.target)) {
			return;
		}

		if (this.dropdown?.isOpen) {
			this.hideMenu(true);
		}
	}
}
